import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_wenzhangxiangqing from '../views/lanhu_wenzhangxiangqing/index.vue'
import lanhu_shouye from '../views/lanhu_shouye/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/lanhu/shouye' },
  // 新的层级化路径
  { path: '/lanhu/shouye', name: 'lanhu_shouye', component: lanhu_shouye },
  { path: '/lanhu/wenzhangxiangqing', name: 'lanhu_wenzhangxiangqing', component: lanhu_wenzhangxiangqing },
  { path: '/lanhu/chengguojiazhi', name: 'lanhu_chengguojiazhi', component: () => import('../views/lanhu_chengguojiazhi/index.vue') },
  { path: '/lanhu/chengguotuiguang', name: 'lanhu_chengguotuiguang', component: () => import('../views/lanhu_chengguotuiguang/index.vue') },
  { path: '/lanhu/chengguotese', name: 'lanhu_chengguotese', component: () => import('../views/lanhu_chengguotese/index.vue') },
  { path: '/lanhu/chengguojianjie', name: 'lanhu_chengguojianjie', component: () => import('../views/lanhu_chengguojianjie/index.vue') },
  // 旧路径兼容性重定向
  { path: '/lanhu_shouye', redirect: '/lanhu/shouye' },
  { path: '/lanhu_wenzhangxiangqing', redirect: '/lanhu/wenzhangxiangqing' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
